import { render, staticRenderFns } from "./ElectricityBillModal.vue?vue&type=template&id=61ac8d8c&scoped=true"
import script from "./ElectricityBillModal.vue?vue&type=script&lang=js"
export * from "./ElectricityBillModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ac8d8c",
  null
  
)

export default component.exports